/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The runtime config.
 * @export
 * @interface V2beta1RuntimeConfig
 */
export interface V2beta1RuntimeConfig {
  /**
   * The runtime parameters of the Pipeline. The parameters will be
   * used to replace the placeholders at runtime.
   * @type {{ [key: string]: object; }}
   * @memberof V2beta1RuntimeConfig
   */
  parameters?: { [key: string]: object };
  /**
   *
   * @type {string}
   * @memberof V2beta1RuntimeConfig
   */
  pipeline_root?: string;
}

/**
 * Check if a given object implements the V2beta1RuntimeConfig interface.
 */
export function instanceOfV2beta1RuntimeConfig(value: object): value is V2beta1RuntimeConfig {
  return true;
}

export function V2beta1RuntimeConfigFromJSON(json: any): V2beta1RuntimeConfig {
  return V2beta1RuntimeConfigFromJSONTyped(json, false);
}

export function V2beta1RuntimeConfigFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V2beta1RuntimeConfig {
  if (json == null) {
    return json;
  }
  return {
    parameters: json['parameters'] == null ? undefined : json['parameters'],
    pipeline_root: json['pipeline_root'] == null ? undefined : json['pipeline_root'],
  };
}

export function V2beta1RuntimeConfigToJSON(json: any): V2beta1RuntimeConfig {
  return V2beta1RuntimeConfigToJSONTyped(json, false);
}

export function V2beta1RuntimeConfigToJSONTyped(
  value?: V2beta1RuntimeConfig | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    parameters: value['parameters'],
    pipeline_root: value['pipeline_root'],
  };
}
